const ACCESS_TOKEN_KEY = "poolfit_admin_session";
const REFRESH_TOKEN_KEY = "poolfit_admin_refresh";

export default {
  // Access token
  getToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  setToken(token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },

  removeToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  },

  // Refresh token
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  setRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  // Set both tokens at once
  setTokens(data) {
    if (data?.token) this.setToken(data.token);
    if (data?.refresh_token) this.setRefreshToken(data.refresh_token);
  },

  clearSession() {
    this.removeToken();
    this.removeRefreshToken();
  },

  getAuthHeaders() {
    const token = this.getToken();
    return token ? { headers: { "X-Access-Token": token } } : {};
  }
};
